<div>
  <div class="flex items-center justify-between mb-4">
    <h2 class="text-lg font-semibold">{{ 'documentProperties.title' | translate }}</h2>
  </div>

  @if (error()) {
    <div class="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded mb-4">
      {{ 'documentProperties.loadError' | translate }}
    </div>
  }
  @if (orderError()) {
    <cmi-notification
      mode="warning"
      [message]="'documentProperties.reorderError' | translate"
      [description]="'documentProperties.reorderErrorDescription' | translate" />
  }
  @if (isLoading()) {
    <div class="flex items-center justify-center p-8">
      <cmi-loading-spinner />
    </div>
  } @else if (properties().length === 0) {
    <div class="text-center text-gray-500 p-8">
      {{ 'documentProperties.noProperties' | translate }}
    </div>
  } @else {
    <div>
      @if (groupedProperties().length > 0) {
        <p class="text-xs font-semibold text-gray-400 uppercase tracking-wide mb-3">
          {{ 'documentProperties.wizardSection' | translate }}
        </p>
        <div class="mb-6">
          <cmi-property-group-list
            [groups]="groupedProperties()"
            [deletingGroupName]="deletingGroupName()"
            [isDraggable]="true"
            (reorder)="onReorder($event)"
            (edit)="navigateToEdit($event)"
            (confirmDelete)="confirmDelete($event)"
            (cancelDelete)="cancelDelete()"
            (removed)="deleteGroup($event)" />
        </div>
      }
      @if (plainGroups().length > 0) {
        <p class="text-xs font-semibold text-gray-400 uppercase tracking-wide mb-3">
          {{ 'documentProperties.plainSection' | translate }}
        </p>
        <cmi-property-group-list
          [groups]="plainGroups()"
          [deletingGroupName]="deletingGroupName()"
          (edit)="navigateToEdit($event)"
          (confirmDelete)="confirmDelete($event)"
          (cancelDelete)="cancelDelete()"
          (removed)="deleteGroup($event)" />
      }
    </div>
  }
</div>
